var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',[_c('ul',[_vm._t("default"),_c('li',[_vm._v("© "+_vm._s(new Date().getFullYear()))])],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }